import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { partnerBonuses } from '@/mocks/strategix';

export default function PartnerProgram() {
  return (
    <section className="relative w-full px-5 md:px-10 py-20 md:py-28">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="Партнёрская программа"
          title="Рекомендуйте STRATEGIX и зарабатывайте"
          description="Приводите к нам клиентов — и получайте процент с каждой их оплаты. Это простой способ монетизировать ваши контакты без вложений."
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {partnerBonuses.map((bonus, index) => (
            <Reveal key={bonus.title} delay={index * 70} className="h-full">
              <div className="h-full p-6 rounded-lg bg-background-100/70 border border-background-200/70 hover:border-primary-400/60 transition-colors">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                  <i className={`${bonus.icon} text-xl`}></i>
                </span>
                <h3 className="mt-5 font-heading text-base md:text-lg text-foreground-950">{bonus.title}</h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{bonus.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}